The input parameter for the `createPositionOpening` mutation.
